import React from 'react'
import TermsBody from './../../molecules/TermsBody/TermsBody'
import header01 from './../../../assets/images/cabezote.png'
import header02 from './../../../assets/images/modelo-celular.png'
import useMediaQuery from './../../../utils/useMediaQuery'
import './term.scss'

function Term() {
	const isMobile = useMediaQuery()
	return (
		<div className="f-roulette-terms">
			<div className="f-roulette-terms__images">
						<img
							src={header02}
							alt="modelo-celular"
							className="f-roulette-terms__images__model"
						/>
						<div className="f-roulette-terms__images__logo">
							<img src={header01} alt="cabezote" />
							<b>Términos y Condiciones</b>
						</div>
			</div>
			<div className="f-roulette-terms__wrapper">
				<TermsBody isMobile={isMobile} />
			</div>
		</div>
	)
}

export default Term
